import { Component, Input, OnInit } from '@angular/core';

// The frame every Overview panel sits in (mockup .panel): drag handle, title, optional Edit link
// and a collapse button. The panel's content is projected in.
// The drag handle works through ngx-dnd's DOM lookup of [ngxDragHandle] inside the draggable.
@Component({
  selector: 'app-overview-panel',
  templateUrl: './overview-panel.component.html',
  styleUrls: ['./overview-panel.component.scss']
})
export class OverviewPanelComponent implements OnInit {
  @Input() title: string;
  // Router link for the panel's Edit button; no button when empty.
  @Input() editLink: string;
  // Key the collapsed state is remembered under (per browser).
  @Input() panelKey: string;

  collapsed = false;

  private static readonly STORAGE_KEY = 'overviewCollapsedPanels';

  ngOnInit() {
    this.collapsed = this.readCollapsed().indexOf(this.panelKey) !== -1;
  }

  toggle() {
    this.collapsed = !this.collapsed;
    const keys = this.readCollapsed().filter(k => k !== this.panelKey);
    if (this.collapsed) {
      keys.push(this.panelKey);
    }
    try {
      localStorage.setItem(OverviewPanelComponent.STORAGE_KEY, JSON.stringify(keys));
    } catch (e) {}
  }

  private readCollapsed(): string[] {
    try {
      const keys = JSON.parse(localStorage.getItem(OverviewPanelComponent.STORAGE_KEY) || '[]');
      return Array.isArray(keys) ? keys : [];
    } catch (e) {
      return [];
    }
  }
}
